var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleColored(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_77_7641)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9891 11.2058C21.9891 10.3045 21.9143 9.64675 21.7523 8.96466H11.2188V13.0328H17.4017C17.2771 14.0438 16.6039 15.5663 15.108 16.5894L15.0871 16.7256L18.4176 19.2466L18.6483 19.2691C20.7674 17.3568 21.9891 14.5432 21.9891 11.2058Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2188 21.9244C14.2479 21.9244 16.7909 20.95 18.6483 19.2691L15.108 16.5894C14.1607 17.235 12.8891 17.6856 11.2188 17.6856C8.25193 17.6856 5.73388 15.7734 4.83626 13.1303L4.70469 13.1412L1.24158 15.76L1.19629 15.883C3.0412 19.464 6.83078 21.9244 11.2188 21.9244Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.83665 13.1303C4.5998 12.4482 4.46273 11.7174 4.46273 10.9622C4.46273 10.207 4.5998 9.47621 4.82419 8.79412L4.81791 8.64885L1.31141 5.98803L1.19668 6.04135C0.436305 7.52736 0 9.19608 0 10.9622C0 12.7283 0.436305 14.397 1.19668 15.883L4.83665 13.1303Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2188 4.23869C13.3254 4.23869 14.7465 5.12785 15.5568 5.87089L18.7231 2.85018C16.7785 1.08405 14.2479 0 11.2188 0C6.83078 0 3.0412 2.46039 1.19629 6.04135L4.8238 8.79412C5.73388 6.15102 8.25193 4.23869 11.2188 4.23869Z",
    fill: "#EB4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_77_7641"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleColored);
export default __webpack_public_path__ + "static/media/googleColored.0a0200eebe2b3e156b66f18ea2fa893c.svg";
export { ForwardRef as ReactComponent };